import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15bdf0fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-site-assigned-users-section" }
const _hoisted_2 = { class: "body bg-white" }
const _hoisted_3 = { class: "title-section-spacing" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Strumenti assegnati", -1))
const _hoisted_5 = { class: "working-sites-users w-full" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"titles grid grid-cols-4\" data-v-15bdf0fe><div class=\"first\" data-v-15bdf0fe></div><div class=\"second\" data-v-15bdf0fe></div><p class=\"third text-left\" data-v-15bdf0fe>Data di inizio</p><div class=\"fourth\" data-v-15bdf0fe></div></div>", 1)
const _hoisted_7 = { class: "users-list list overflow-y-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAssignedTool = _resolveComponent("UserAssignedTool")!
  const _component_AssignToolItem = _resolveComponent("AssignToolItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "add-document text-primary block float-right font-bold",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingAddAssignment = true))
        }, "Aggiungi strumenti"),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignedToolItems, (toolItem) => {
            return (_openBlock(), _createBlock(_component_UserAssignedTool, { "model-value": toolItem }, null, 8, ["model-value"]))
          }), 256)),
          (_ctx.isShowingAddAssignment)
            ? (_openBlock(), _createBlock(_component_AssignToolItem, {
                key: 0,
                "user-id": _ctx.userId,
                "existing-assignments": _ctx.modelValue,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingAddAssignment = false))
              }, null, 8, ["user-id", "existing-assignments"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}